import { Tetris } from './components/tetris';

export const App = () => {
	return <Tetris />;
};
